module.exports = __webpack_public_path__ + "static/media/running-sensor.acc31725.png";